module.exports = __webpack_public_path__ + "static/media/Hero_Image_Tablet_3.d51d0810.jpg";